export default "__VITE_PUBLIC_ASSET__5ec209f1__"